/**
 * Lightweight collection filter/sort for BHCR collection grid.
 * Replaces Dawn facets.js which expects different DOM selectors.
 */
class BhcrCollectionFilters extends HTMLElement {
  static listenersBound = false;

  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.debouncedRender = debounce(() => this.renderCollection(), 500);
    this.form.addEventListener('input', this.debouncedRender);
    this.form.addEventListener('change', this.debouncedRender);

    if (!BhcrCollectionFilters.listenersBound) {
      BhcrCollectionFilters.listenersBound = true;
      window.addEventListener('popstate', () => BhcrCollectionFilters.renderFromUrl());
    }
  }

  static getSectionId() {
    return document.querySelector('.bhcr-collection')?.dataset.id;
  }

  static collectFormParams() {
    const params = new URLSearchParams();
    document.querySelectorAll('.bhcr-collection bhcr-collection-filters form').forEach((form) => {
      new FormData(form).forEach((value, key) => {
        if (value !== '') params.set(key, value);
      });
    });
    return params.toString();
  }

  static renderFromUrl() {
    const sectionId = BhcrCollectionFilters.getSectionId();
    if (!sectionId) return;

    const searchParams = window.location.search.replace(/^\?/, '');
    BhcrCollectionFilters.fetchAndReplace(sectionId, searchParams);
  }

  static fetchAndReplace(sectionId, searchParams) {
    const grid = document.getElementById('ProductGridContainer');
    if (grid) grid.setAttribute('aria-busy', 'true');

    const url = `${window.location.pathname}?section_id=${sectionId}${searchParams ? `&${searchParams}` : ''}`;

    return fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('ProductGridContainer');
        const currentGrid = document.getElementById('ProductGridContainer');
        if (newGrid && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
        }
      })
      .finally(() => {
        if (grid) grid.removeAttribute('aria-busy');
      });
  }

  renderCollection() {
    const sectionId = BhcrCollectionFilters.getSectionId();
    if (!sectionId) {
      this.form.submit();
      return;
    }

    const searchParams = BhcrCollectionFilters.collectFormParams();

    BhcrCollectionFilters.fetchAndReplace(sectionId, searchParams).then(() => {
      const nextUrl = searchParams ? `${window.location.pathname}?${searchParams}` : window.location.pathname;
      history.pushState({ searchParams }, '', nextUrl);
    });
  }
}

customElements.define('bhcr-collection-filters', BhcrCollectionFilters);
